import { render } from "./Captcha.vue?vue&type=template&id=2d969f22"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"

import "./Captcha.vue?vue&type=style&index=0&id=2d969f22&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__